module.exports = __webpack_public_path__ + "img/howtouse02.86928bed.png";